export const LinkType = 'LINK';
